import { LateFeeConfigProps } from '../types/index';

const initialLateFeeConfigData: LateFeeConfigProps = {
  school: '',
  chequeBounceCharges: null,
  enachBounceCharges: null,
  fineType: '',
  lateFeeCharges: {
    amount: null,
    percentage: null
  },
  maxLateFee: null,
  proRatedConfig: {
    enabled: false,
    proRateAfterCycles: null
  }
};

const fineTypeOption = [
  { label: 'Per day', value: 'PER_DAY' },
  { label: 'Per Month', value: 'PER_MONTH' }
];

export { initialLateFeeConfigData, fineTypeOption };
